import type { Project } from './types.tsx';

// set

export const SET = 'project.SET' as const;
export type SetPayload = Project;
export type SetAction = {
	type: typeof SET;
	payload: SetPayload;
};
export const set = (payload: SetPayload): SetAction => ({
	type: SET,
	payload,
});

export type Action = SetAction;
